import React, { useContext, useEffect, useState, useRef } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Bid({ symbol_id, adv, digit, symbolType }) {
  const socket = useContext(SocketContext);
  const [bid, setBid] = useState(0);
  const [tickColor, setTickColor] = useState("text-[var(--text)]");
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!socket || !symbol_id) return;

    socket.emit("giverate", symbol_id);

    const tradeListener = (data) => {
      if (data && typeof data.Bid !== "undefined") {
        const newBid = data.Bid;

        setBid((prevBid) => {
          if (prevBid && newBid > prevBid) {
            setTickColor("text-[var(--buymeta)]"); // price up
          } else if (prevBid && newBid < prevBid) {
            setTickColor("text-[var(--sellmeta)]"); // price down
          }

          // Reset color after 500ms
          clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(() => {
            setTickColor("text-[var(--text)]");
          }, 500);

          return newBid;
        });
      }
    };

    socket.on(`trade${symbol_id}`, tradeListener);

    return () => {
      socket.off(`trade${symbol_id}`, tradeListener);
      clearTimeout(timeoutRef.current);
    };
  }, [socket, symbol_id]);

  // Format price
  const formatted = Number(bid).toFixed(digit);
  const chars = formatted.split("");

  const bigSize = "text-[1.6em] leading-none";
  const smallSize = "text-[0.85em] leading-none relative -top-[5px]";

  const tickSize =
    symbolType === "forex_future" ? "text-[14px]" : "text-[15px]";

  return (
    <span
      style={{ fontVariantNumeric: "tabular-nums" }}
      className={`text-right leading-none tracking-[-0.03em] ${
        symbolType === "crypto_future"
          ? "text-[13px]"
          : adv
          ? tickSize
          : "text-[13px] font-semibold"
      } transition-all duration-200 font-normal ${tickColor}`}
    >
      {adv && (digit === 3 || digit === 4 || digit === 5)
        ? chars.map((ch, i) => {
            const lastIndex = chars.length - 1;
            const secondLast = chars.length - 2;
            const thirdLast = chars.length - 3;

            const isBig = i === secondLast || i === thirdLast;
            const isSmall = i === lastIndex;

            return (
              <span
                key={i}
                className={`inline-block font-semibold ${
                  isBig ? bigSize : isSmall ? smallSize : "leading-none"
                }`}
                style={{ marginRight: "-1px" }}
              >
                {ch}
              </span>
            );
          })
        : adv && (digit === 2 || digit === 1 || digit === 0)
        ? chars.map((ch, i) => {
            const isLastTwo = i >= chars.length - 2;

            return (
              <span
                key={i}
                className={`inline-block font-semibold leading-none ${
                  isLastTwo ? bigSize : ""
                }`}
                style={{ marginRight: "-1px" }}
              >
                {ch}
              </span>
            );
          })
        : bid}
    </span>
  );
}